export enum GradeInvStatusEnum {
    REPORTED = 'Reported',
    ASSIGNED = 'Assigned',
}